module.exports = __webpack_public_path__ + "img/ico_msg-accent.f2881ee1.svg";